/**
 * @file Manages the fonts values for the theme Modern V1.
 * @author kkumari
 */export default {
  FONT_MERRIWEATHER_BOLD: 'MerriweatherBold',
  FONT_CABIN_BOLD: 'CabinBold',
  FONT_CABIN_MEDIUM: 'CabinMedium',
  FONT_SIZE_BASE: '16px',
  FONT_SIZE_SMALL: '10px',
  FONT_SIZE_DEFAULT: '14px',
  FONT_LETTER_SPACING_DEFAULT: '1.4px',
  FONT_LINE_HEIGHT_DEFAULT: '18px',
  FONT_ICONS: 'Arial, sans-serif',
  FONT_WEIGHT_BOLD: 'bold',
  FONT_WEIGHT_NORMAL: 'normal',
  FONT_WEIGHT_500: '500',
  //Mobile values
  //H1
  FONT_SIZE_H1: '42px',
  LINE_HEIGHT_H1: '52px',
  LETTER_SPACING_H1: 'normal',
  //H2
  FONT_SIZE_H2: '32px',
  LINE_HEIGHT_H2: '40px',
  LETTER_SPACING_H2: 'normal',
  //H3
  FONT_SIZE_H3: '26px',
  LINE_HEIGHT_H3: '33px',
  LETTER_SPACING_H3: 'normal',
  //H4
  FONT_SIZE_H4: '18px',
  LINE_HEIGHT_H4: '23px',
  LETTER_SPACING_H4: '0.18px',
  //H5
  FONT_SIZE_H5: '13px',
  LINE_HEIGHT_H5: '16px',
  LETTER_SPACING_H5: '0.13px',
  //P
  FONT_SIZE_P: '16px',
  LINE_HEIGHT_P: '28px',
  LETTER_SPACING_P: '0.32px',
  DESKTOP: {
    //Desktop values
    //H1
    FONT_SIZE_H1: '70px',
    LINE_HEIGHT_H1: '80px',
    LETTER_SPACING_H1: 'normal',
    //H2
    FONT_SIZE_H2: '38px',
    LINE_HEIGHT_H2: '48px',
    LETTER_SPACING_H2: 'normal',
    //H3
    FONT_SIZE_H3: '28px',
    LINE_HEIGHT_H3: '35px',
    LETTER_SPACING_H3: 'normal',
    //H4
    FONT_SIZE_H4: '18px',
    LINE_HEIGHT_H4: '23px',
    LETTER_SPACING_H4: '0.18px',
    //H5
    FONT_SIZE_H5: '13px',
    LINE_HEIGHT_H5: '16px',
    LETTER_SPACING_H5: '0.52px',
    //P
    FONT_SIZE_P: '16px',
    LINE_HEIGHT_P: '28px',
    LETTER_SPACING_P: 'normal'
  },
  FONT_FACES: ['MerriweatherBold', 'CabinBold', 'CabinMedium']
};